export const setSelectFeildValue = (form, selected, id) => {
  form.setFieldValue(id, selected);
};
